import { Components, Theme } from "@mui/material/styles";
import alertTheme from "./alertTheme";
import autoCompleteTheme from "./autoCompleteTheme";
import buttonTheme from "./buttonTheme";
import cardTheme from "./cardTheme";
import datePickerTheme from "./datePickerTheme";
import dropDownTheme from "./dropDownTheme";
import listTheme from "./listTheme";
import tableTheme from "./tableTheme";
import textFieldTheme from "./textFieldTheme";
import typographyTheme from "./typographyTheme";
import containerTheme from "./containerTheme";
import breadcrumbsTheme from "./breadcrumbsTheme";
import formHelperTextTheme from "./formHelperTextTheme";

export const MuiOverrides: Components<Omit<Theme, "components">> = {
  MuiAlert: alertTheme,
  MuiAutocomplete: autoCompleteTheme,
  MuiButton: buttonTheme,
  MuiCard: cardTheme,
  MuiDatePicker: datePickerTheme,
  MuiList: listTheme,
  MuiSelect: dropDownTheme,
  MuiTable: tableTheme,
  MuiTextField: textFieldTheme,
  MuiContainer: containerTheme,
  MuiBreadcrumbs: breadcrumbsTheme,
  MuiTypography: typographyTheme,
  MuiFormHelperText: formHelperTextTheme,
};
